/** Browser tabs start clipping the label after about this many characters. */
export const PAGE_TITLE_MAX_LENGTH = 30; // with favicon

const TITLE_SEPARATOR = ' | ';
const TITLE_ELLIPSIS = '…';

export function formatPageTitle(parts: readonly string[]): string {
  return parts
    .map(part => part.trim())
    .filter(part => part.length > 0)
    .join(TITLE_SEPARATOR);
}

export function buildDocumentTitle(baseTitle: string, pageTitle?: string | null): string {
  const label = pageTitle?.trim() ?? '';
  const base = baseTitle.trim();

  if (!label) {
    return base;
  }

  if (!base) {
    return collapsePageTitle(label);
  }

  const fullTitle = `${base}${TITLE_SEPARATOR}${label}`;

  if (fullTitle.length <= PAGE_TITLE_MAX_LENGTH) {
    return fullTitle;
  }

  return collapsePageTitle(label, base);
}

function collapsePageTitle(pageTitle: string, baseTitle = ''): string {
  const fragments = pageTitle
    .split(TITLE_SEPARATOR)
    .map(part => part.trim())
    .filter(part => part.length > 0);
  const lastFragment = fragments.at(-1) ?? pageTitle;
  const prefix = baseTitle ? `${baseTitle}${TITLE_SEPARATOR}` : '';

  if (fragments.length < 2) {
    return `${prefix}${lastFragment}`;
  }

  return `${prefix}${TITLE_ELLIPSIS}${TITLE_SEPARATOR}${lastFragment}`;
}

/*
 * If the full chain fits within that limit, it stays as it is: AG: CRM | Agencies | List.
 * If the chain exceeds the limit, it collapses: AG: CRM | … | List.
 * */
